
import { Toast } from "vant";
import { Component, Vue, Prop } from "vue-property-decorator";
import { extractrList, extractInfo, readExtract } from "@/req/pay";
import Detail from "./detail.vue";
import NavBar from "@/components/navBar.vue";
@Component({
  components: {
    Detail,
    NavBar,
  },
})
export default class Logout extends Vue {
  public count = 0;
  public isLoading = false;
  public isShowDetail = false;
  public loading = false;
  public page = 1;
  public size = 10;
  public type: any = 2;
  public list: any = [];
  public detailList = {};
  public finished = false;
  public status = false;
  public flag = true;
  public finishedText = "";
  public created() {
    //   url截取token
    const obj: any = this.$fn.parseQuery(window.location.href);
    // const token = this.$route.query.token;
    // 打印token
    // Dialog.alert({
    //   title: "token",
    //   message: `${obj.token}`,
    //   theme: "round-button",
    // }).then(() => {
    //   // on close
    // });
    // console.log(obj);
    if (obj.token) {
      this.$fn.cookies.setToken(obj.token);
      this.$fn.cookies.setShowNav(1);
    }
    if (obj.device) {
      this.$fn.cookies.setIsios(obj.device);
    }
    if (obj.version) {
      this.$fn.cookies.setVersion(obj.version);
    }
    if (obj.type) {
      this.type = obj.type;
    }
  }
  public mounted() {
    // if (this.$route.params.type) {
    //   sessionStorage.setItem("extractType", this.$route.params.type);
    // }
    // this.type = sessionStorage.getItem("extractType");
    this.getExtractrList();
  }
  public async getExtractrList() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      type: this.type,
      page: this.page,
      size: 10,
    };
    const res = await extractrList(obj);
    if (res.code == 200) {
      this.loading = false;
    }
    if (this.flag && res.code == 200 && JSON.stringify(res.data.data) == "[]") {
      this.flag = false;
      this.status = false;
      this.finished = true;
      this.finishedText = "没有更多了";
    }
    if (res.code == 200 && JSON.stringify(res.data.data) != "[]") {
      this.list = [...this.list, ...res.data.data];
      this.loading = false;
      if (
        this.size === res.data.data.length &&
        res.data.total > this.list.length
      ) {
        this.status = true;
        this.finished = false;
      } else {
        this.status = false;
        this.finished = true;
        this.finishedText = "没有更多了";
      }
    }
  }
  public confirmDetail(val) {
    this.isShowDetail = val;
  }
  public onLoad() {
    if (!this.status) {
      return false;
    }
    this.page = this.page + 1;
    this.getExtractrList();
  }
  public onRefresh() {
    setTimeout(() => {
      Toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 1000);
  }
  public async onRecord(index) {
    const arr = this.list[index];
    this.detailList = {
      data: arr,
      type: this.type,
    };
    this.getReadExtract(this.type);
    this.isShowDetail = true;
  }
  // 更改提现列表小红点状态
  public async getReadExtract(val) {
    const res = await readExtract({
      type: val,
    });
  }
}
